import * as React from 'react';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

const styles = require('./SmtpAccountInformation.scss');

export interface SmtpAccountInformationProps {
    useAltUserNamePassword: () => boolean;
    onUpdateUseAltUserNamePassword: (value: boolean) => void;
    onUpdateSmtpUserName: (value: string) => void;
    onUpdateSmtpPassword: (value: string) => void;
}

@observer
export default class SmtpAccountInformation extends React.Component<
    SmtpAccountInformationProps,
    {}
> {
    private onUseAltUsernamePasswordChecked = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) => {
        this.props.onUpdateUseAltUserNamePassword(checked);
    };

    render() {
        return (
            <div>
                <Checkbox
                    className={styles.checkbox}
                    label={strings.options_connected_advanced_altUserNamePasswordCheckbox}
                    defaultChecked={false}
                    onChange={this.onUseAltUsernamePasswordChecked}
                />
                {this.props.useAltUserNamePassword() && (
                    <div>
                        <TextField
                            className={styles.textbox}
                            label={strings.options_connected_advanced_altUserNameTextField}
                            onChanged={this.props.onUpdateSmtpUserName}
                        />
                        <TextField
                            className={styles.textbox}
                            label={strings.options_connected_advanced_altPasswordTextField}
                            type="password"
                            onChanged={this.props.onUpdateSmtpPassword}
                        />
                    </div>
                )}
            </div>
        );
    }
}
